import { ProfileIcon } from '../Icons';
import './Header.css';

interface HeaderProps {
  onProfileClick?: () => void;
}

export function Header({ onProfileClick }: HeaderProps) {
  return (
    <header className="header">
      <h1 className="header__title">SWOL</h1>
      <div className="header__subtitle-row">
        <span className="header__dash">──</span>
        <span className="header__star">★</span>
        <span className="header__subtitle">WITH FRIENDS</span>
        <span className="header__star">★</span>
        <span className="header__dash">──</span>
      </div>
      <div className="header__rule"></div>

      {onProfileClick && (
        <button className="header__profile-button" onClick={onProfileClick} aria-label="Profile">
          <ProfileIcon size={24} />
        </button>
      )}
    </header>
  );
}
